import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "./index.css";
import App from "./App";

const container = document.getElementById("root") as HTMLElement;

const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// When react-snap has pre-rendered the page, the #root already contains HTML:
// hydrate it instead of re-rendering from scratch. Otherwise, normal render.
if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}
